<template>
  <div class="ai-widget">
    <transition name="ai-panel">
      <section v-if="open" class="ai-widget-panel" role="dialog" aria-label="Raviremmi-apuri">
        <header class="ai-widget-header">
          <div>
            <p class="eyebrow">Kokeellinen apuri</p>
            <h2>Raviremmi-apuri</h2>
            <p>Apuri käyttää Raviremmin omaa dataa ja toimii parhaiten pisteisiin liittyvissä kysymyksissä.</p>
          </div>
          <button class="close-button" type="button" aria-label="Sulje apuri" @click="open = false">×</button>
        </header>
        <AiAssistantPanel compact />
      </section>
    </transition>

    <button class="ai-widget-button" type="button" :aria-expanded="open" @click="open = !open">
      <span class="button-dot">AI</span>
      <span>Apuri</span>
    </button>
  </div>
</template>

<script>
import { ref } from 'vue';
import AiAssistantPanel from './AiAssistantPanel.vue';

export default {
  name: 'AiAssistantWidget',
  components: { AiAssistantPanel },
  setup() {
    const open = ref(false);
    return { open };
  },
};
</script>

<style scoped>
.ai-widget {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  pointer-events: none;
}

.ai-widget-button,
.ai-widget-panel {
  pointer-events: auto;
}

.ai-widget-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(100, 255, 218, 0.36);
  border-radius: 999px;
  padding: 11px 16px 11px 11px;
  color: #0a192f;
  background: linear-gradient(135deg, #64ffda, #ffc65c);
  box-shadow: 0 16px 34px rgba(2, 12, 27, 0.38);
  font-weight: 900;
  cursor: pointer;
}

.button-dot {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #64ffda;
  background: #0a192f;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
}

.ai-widget-panel {
  width: min(620px, calc(100vw - 28px));
  max-height: min(760px, calc(100vh - 104px));
  overflow: auto;
  border: 1px solid rgba(100, 255, 218, 0.24);
  border-radius: 20px;
  background:
    radial-gradient(circle at top right, rgba(255, 198, 92, 0.13), transparent 34%),
    #0a192f;
  box-shadow: 0 24px 64px rgba(2, 12, 27, 0.56);
  padding: 16px;
}

.ai-widget-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.ai-widget-header h2,
.ai-widget-header p {
  margin: 0;
}

.ai-widget-header h2 {
  color: #64ffda;
  font-size: 1.35rem;
}

.ai-widget-header p:not(.eyebrow) {
  margin-top: 6px;
  color: #b7c6dc;
  line-height: 1.5;
}

.eyebrow {
  margin: 0 0 4px;
  color: #ffc65c;
  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.close-button {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(100, 255, 218, 0.22);
  border-radius: 50%;
  color: #ccd6f6;
  background: rgba(17, 34, 64, 0.9);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.ai-panel-enter-active,
.ai-panel-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.ai-panel-enter-from,
.ai-panel-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.98);
}

@media (max-width: 640px) {
  .ai-widget {
    right: 12px;
    bottom: 12px;
  }

  .ai-widget-panel {
    max-height: calc(100vh - 88px);
    padding: 12px;
  }

  .ai-widget-button {
    padding: 9px 13px 9px 9px;
  }
}
</style>
